import { render } from "./opTableServerSide.vue?vue&type=template&id=5d399d22&ts=true"
import script from "./opTableServerSide.vue?vue&type=script&lang=ts"
export * from "./opTableServerSide.vue?vue&type=script&lang=ts"

import "./opTableServerSide.vue?vue&type=style&index=0&id=5d399d22&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__